import { useContext } from 'react';
import { M as MobileThemeContext } from './MobileThemeContext-ILBGocWR.js';

function useIsMobile() {
  var _useContext;
  const {
    isMobile
  } = (_useContext = useContext(MobileThemeContext)) !== null && _useContext !== void 0 ? _useContext : {
    isMobile: false
  };
  return isMobile;
}

export { useIsMobile as u };
//# sourceMappingURL=useIsMobile-B-VP6bHU.js.map
